import type { ChallengeWithCountsDto } from '@@types/api.types';
import { IconButton } from '@components/core/icon-button.component';
import { BlueLabel } from '@components/shared/blue-label.component';
import { ExpandableText } from '@components/shared/expandable-text.component';
import { Tile } from '@components/shared/tile.component';
import { EditIcon } from 'lucide-react';
import type { FC } from 'react';
import { useState } from 'react';
import { ChallengeModal } from './challenge-modal.component';

type ChallengeHeaderProps = {
  challenge?: ChallengeWithCountsDto;
  isLoading?: boolean;
};

export const ChallengeHeader: FC<ChallengeHeaderProps> = (props) => {
  const { challenge, isLoading } = props;
  const [isHovering, setIsHovering] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleEditClick = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Tile
        className=""
        isLoading={isLoading}
        onMouseEnter={() => setIsHovering(true)}
        onMouseLeave={() => setIsHovering(false)}
      >
        <div className="flex flex-col gap-4">
          <div className="flex flex-row justify-between gap-4 w-full">
            <div className="flex flex-col w-full">
              <div className="text-lg font-medium leading-5 text-gray-800">{challenge?.name}</div>
              <BlueLabel text="Tech Challenge" />
              {challenge?.description && (
                <ExpandableText
                  className="text-xs font-normal mt-2 text-gray-500"
                  maxLines={2}
                  text={challenge.description}
                />
              )}
            </div>
            <IconButton
              ariaLabel="Edit Challenge"
              icon={<EditIcon />}
              isVisible={isHovering}
              onClick={handleEditClick}
              variant="secondary"
            />
          </div>
        </div>
      </Tile>

      {isModalOpen && challenge && (
        <ChallengeModal
          challenge={challenge}
          isEdit={true}
          isOpen={isModalOpen}
          onClose={handleCloseModal}
        />
      )}
    </>
  );
};
